import axios from "axios";
import { api } from "~/router/apiConfig";

export function create(contractId, domainId, request) {
  return axios.post(
    api.path("contractDomainRecord.store", {
      contractId: contractId,
      domainId: domainId
    }),
    request
  );
}

export function update(contractId, domainId, recordId, request) {
  return axios.put(
    api.path("contractDomainRecord.update", {
      contractId: contractId,
      domainId: domainId,
      recordId: recordId
    }),
    request
  );
}

export function list(contractId, domainId, request) {
  return axios.get(
    api.path("contractDomainRecord.index", {
      contractId: contractId,
      domainId: domainId
    }),
    request
  );
}

export function show(contractId, domainId, recordId) {
  return axios.get(
    api.path("contractDomainRecord.show", {
      contractId: contractId,
      domainId: domainId,
      recordId: recordId
    })
  );
}

export function remove(contractId, domainId, recordId) {
  return axios.delete(
    api.path("contractDomainRecord.remove", {
      contractId: contractId,
      domainId: domainId,
      recordId: recordId
    })
  );
}

export function turnOn(contractId, domainId, recordId) {
  return axios.put(
    api.path("contractDomainRecord.turnOn", {
      contractId: contractId,
      domainId: domainId,
      recordId: recordId
    })
  );
}

export function turnOff(contractId, domainId, recordId) {
  return axios.put(
    api.path("contractDomainRecord.turnOff", {
      contractId: contractId,
      domainId: domainId,
      recordId: recordId
    }),
  );
}
